export default {
      id: "weather__day-mostlyc-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.svg#weather__day-mostlyc",
      toString: function () {
        return this.url;
      }
    }